module.exports = __webpack_public_path__ + "components/flag/static/square/dj-d88b8e3a44017c72192af1814532a81e.svg";